import { apiRequest, getRestErrorMessage } from 'common-src/features/rest';
import { HttpMethods } from 'common-src/features/rest/constants';

const getErrorMessage = (body, fallbackMessage) =>
  getRestErrorMessage(body) || body?.message || body?.detail || fallbackMessage;

export const createMemberPortalAccess = async (patientId) => {
  const response = await apiRequest({
    endpoint: 'patientPortalBackend/createMemberPortalAccess',
    method: HttpMethods.Post,
    body: {
      patient_id: patientId,
    },
  });

  const body = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(getErrorMessage(body, 'Failed to create member portal access.'));
  }

  return body;
};

export const syncPortalData = async (patientId) => {
  const response = await apiRequest({
    endpoint: `members/${patientId}/syncPortalData`,
    method: HttpMethods.Post,
  });

  const body = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(getErrorMessage(body, 'Failed to sync portal data.'));
  }

  return body;
};

export const createMissingMemberPortalAccess = async (limit) => {
  const response = await apiRequest({
    endpoint: 'jobRequests/createMissingMemberPortalAccess',
    method: HttpMethods.Post,
    queryParams: { limit },
  });

  const body = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(getErrorMessage(body, 'Failed to create portal access.'));
  }

  return body;
};
